<template>
  <v-container>
    <img src="../../assets/breadcrumb1.svg" />
    <h1 class="title">How will your LLC be managed?</h1>
    <h2 class="subheading">Who are the {{ title }}(s) of the business?</h2>
    <v-form ref="form">
      <v-radio-group v-model="member">
        <v-radio :value="true" label="Members" />
        <v-radio :value="false" label="Managers" />
      </v-radio-group>
      <PeopleField v-model="people" :label="title" />
    </v-form>
    <v-layout justify-space-around>
      <v-btn @click="$router.go(-1);">Back</v-btn>
      <v-btn color="info" @click="done">Continue</v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/database';
import { mapState } from 'vuex';
import PeopleField from '../util/PeopleField.vue';

const db = firebase.database;

export default {
  components: { PeopleField },
  data: () => ({
    member: true,
    people: [''],
  }),
  computed: {
    ...mapState(['token']),
    title() {
      return this.member ? 'member' : 'manager';
    },
  },
  methods: {
    async done() {
      if (!this.$refs.form.validate()) return;
      this.people = this.people.filter(p => !!p); // get rid of empty fields
      await db()
        .ref(`info/${this.token}`)
        .update({
          people: this.people,
        });
      this.$router.push({ path: '/stage4/agent' });
    },
  },
};
</script>
